import { DetectionInstructions } from './detectionInstructions'
import { RegexDynamicInputs } from '../../../common/regexDynamicInputs'
import { PatternOptions } from '../../../../types'
import { usePolicyParametersContext } from '../../../../context/policyParametersContext'
import { dataTypeOptions } from '../../basicDetails'
import { BASIC_PATTERS_MAP } from '../../../../constants'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Select, Tooltip, Typography } from '@lightbeamai/design-system'

const MAX_PATTERNS = 8

export const AssociatedPatterns = () => {
  const intl = useIntl()
  const {
    // mode,
    detection,
    patchDetection
    // handleDetectionTypeChange
  } = usePolicyParametersContext()
  // const { isView } = mode

  const isBasic = detection.detectionType === PatternOptions.BASIC

  // const radioOptions = Object.values(PatternOptions).map((option) => ({
  //   children: intl.formatMessage({ id: `policy.settings.paramerters.${option}` }),
  //   value: option
  // }))

  const patterns = useMemo(() => {
    if (!detection.regexPatternTypes?.[0]) return []
    return BASIC_PATTERS_MAP[detection.regexPatternTypes?.[0]]
  }, [detection.regexPatternTypes])

  const patternsToShow = patterns.slice(0, MAX_PATTERNS)
  const remainPatterns = patterns.slice(MAX_PATTERNS)

  return (
    <div className="key-value-configuration-card associated-patterns">
      <DetectionInstructions transIdKey={isBasic ? 'basic' : 'patterns'} />
      <div className=" xs-my-16">
        {/* <RadioGroup
          value={detection.detectionType}
          onChange={(e) => handleDetectionTypeChange(e.target.value as PatternOptions)}
          className="xs-mb-16 detection-radio-group"
          options={radioOptions}
          disabled={isView}
        /> */}
        {isBasic ? (
          <>
            <Select
              value={detection.regexPatternTypes?.[0]}
              onChange={(val) => patchDetection({ regexPatternTypes: [val] })}
              placeholder={intl.formatMessage({
                id: 'policy.settings.parameters.basicDetails.dataType'
              })}
              style={{ width: '200px' }}
              className="regex-pattern-type-select"
              options={dataTypeOptions}
              disabled={true}
            />
            <Typography className="xs-mt-8">
              {intl.formatMessage({ id: 'policy.settings.paramerters.basic.info' })}
            </Typography>
            {patternsToShow.length > 0 && (
              <Typography as="span" variant="baseMinus2">
                {patternsToShow.join(', ')}
              </Typography>
            )}
            {remainPatterns.length > 0 && (
              <Tooltip
                placement="top"
                arrow
                title={
                  <Typography color="white" variant="baseMinus2">
                    {remainPatterns.join(', ')}
                  </Typography>
                }
              >
                <Typography variant="baseMinus2" as="span" className="xs-ml-4">
                  {intl.formatMessage(
                    { id: 'policy.settings.paramerters.basic.moreText' },
                    { count: remainPatterns.length }
                  )}
                </Typography>
              </Tooltip>
            )}
          </>
        ) : (
          <RegexDynamicInputs />
        )}
      </div>
    </div>
  )
}
